<template>
  <div>
    <component-table
      :hide-search-input="true"
      :columns="columns"
      :data="list"
      :actions="actions"
      :total="count"
      @add="showAddModal"
      @delete="showDeleteDialog($event.permission.id)"
    />

    <permission-modal v-if="showModal" :show="showModal" @close="hideModal" @save="add" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PermissionModal from '@/components/modals/PermissionRelationModal';
import ComponentTable from '@/components/table/Table';
import { boolean } from '@/filters/boolean';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania uprawnień.',
  getError: 'Wystąpił błąd podczas pobierania danych uprawnienia.',
  added: 'Dodano uprawnienie.',
  addError: 'Nie udało się dodać uprawnienia.',
  updated: 'Zaktualizowano dane uprawnienia.',
  updateError: 'Nie udało się zaktualizować danych uprawnienia.',
  deleteConfirm: 'Czy na pewno chcesz usunąć uprawnienie?',
  deleted: 'Usunięto uprawnienie.',
  deleteError: 'Nie udało się usunąć uprawnienia.'
};

// @vuese
// Lista uprawnień roli
// @group Role
export default {
  components: { ComponentTable, PermissionModal },
  mixins: [listMixin('role/permission', messages)],
  data() {
    return {
      columns: [
        { name: 'name', displayName: 'Nazwa' },
        { name: 'allowedTranslation', displayName: 'Dozwolone' },
        { name: 'fromParentTranslation', displayName: 'Dziedziczone' }
      ],
      actions: [DELETE_ACTION]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.role.permission.list.map(perm => {
          perm.name = perm.permission.name;
          perm.allowedTranslation = boolean(perm.allowed);
          perm.fromParentTranslation = boolean(perm.fromParent);
          return perm;
        }),
      count: state => state.role.permission.count
    })
  }
};
</script>
